function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Controller } from 'stimulus';
import { addFavoriteSpot, deleteFavoriteSpot, saveFavoriteSpotId } from '../store/actions'; // Sets the add or remove button visible and creates and removes favorite spots.
//
// HTML Snippet:
//
// <div data-controller="favorite-spot"
//      data-favorite-spot-jc-id="1"
//      data-favorite-spot-hide-class="d-none">
//   <button data-target="favorite-spot.addButton"
//           data-action="favorite-spot#add">
//     Add Spot to favorite spots.
//   </button>
//
//   <button data-target="favorite-spot.deleteButton"
//           data-action="favorite-spot#delete">
//     Remove Spot from favorite spots.
//   </button>
// </div>

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      this.unsubscribe = this.store.subscribe(this.update.bind(this));
      this.update();
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.unsubscribe();
    }
  }, {
    key: "update",
    value: function update() {
      if (this.getFavoriteSpot()) {
        this.addButtonTarget.classList.add(this.hideClass);
        this.deleteButtonTarget.classList.remove(this.hideClass);
      } else {
        this.addButtonTarget.classList.remove(this.hideClass);
        this.deleteButtonTarget.classList.add(this.hideClass);
      }
    }
  }, {
    key: "getFavoriteSpot",
    value: function getFavoriteSpot() {
      var _this = this;

      if (this.externalId) {
        return Object.values(this.store.getState().favoriteSpots).find(function (spot) {
          return spot.externalId === _this.externalId;
        });
      }

      return this.store.getState().favoriteSpots[this.jcId];
    }
  }, {
    key: "add",
    value: function add(event) {
      event.preventDefault();
      this.store.dispatch(addFavoriteSpot({
        id: this.jcId,
        externalId: this.externalId
      }));
    }
  }, {
    key: "delete",
    value: function _delete(event) {
      event.preventDefault();
      this.store.dispatch(deleteFavoriteSpot(this.getFavoriteSpot().id));
    }
  }, {
    key: "hideClass",
    get: function get() {
      return this.element.getAttribute('data-jc-favorite-spot-hide-class');
    }
  }, {
    key: "jcId",
    get: function get() {
      return parseInt(this.element.getAttribute('data-jc-favorite-spot-jc-id'), 10);
    }
  }, {
    key: "externalId",
    get: function get() {
      return parseInt(this.element.getAttribute('data-jc-favorite-spot-id'), 10);
    }
  }, {
    key: "store",
    get: function get() {
      return this.application.store;
    }
  }]);

  return _default;
}(Controller);

_default.targets = ['addButton', 'deleteButton'];
export { _default as default };